<template>
    <div class="main">
        <myheader></myheader>
        <div class="mains flex">
            <myleft></myleft>
            <div class="right">
                <div class="top flex">
                    <div class="btn flex">
                        <el-button type="danger" icon="el-icon-delete" size="small" @click="deleteSelect">删除选中项</el-button>
                    </div>
                    <el-form :inline="true" :model="formInline" :rules="rules" ref="formInline" class="demo-form-inline flex">
                        <el-form-item prop="entrust_id">
                            <el-input v-model="formInline.entrust_id" placeholder="委托单位id"></el-input>
                        </el-form-item>
                        <el-form-item prop="serial">
                            <el-input v-model="formInline.serial" placeholder="委托编号"></el-input>
                        </el-form-item>
                        <el-form-item prop="date">
                            <el-date-picker v-model="formInline.date" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd" @change="changeDate">
                            </el-date-picker>
                        </el-form-item>
                        <el-form-item prop="entrust_phone">
                            <el-input v-model="formInline.entrust_phone" placeholder="姓名"></el-input>
                        </el-form-item>
                        <el-form-item>
                            <el-button type="primary" @click="submitForm('formInline')">搜索</el-button>
                        </el-form-item>
                    </el-form>
                </div>
                <div class="bot">
                    <el-table
                        class="yingshou"
                        ref="singleTable"
                        v-loading.fullscreen.lock="loading" element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.8)"
                        :data="tableData"
                        border
                        stripe
                        style="width: 100%"
                        max-height="95%"
                        :default-sort = "{prop: 'id', order: 'descending'}"
                        @selection-change="handleSelectionChange">
                        <el-table-column
                        type="selection"
                        width="113">
                        </el-table-column>
                        <el-table-column
                        fixed
                        prop="id"
                        label="ID"
                        width="113">
                        </el-table-column>
                        <el-table-column
                        prop="collect_money"
                        label="收款金额（￥）"
                        width="155">
                        </el-table-column>
                        <el-table-column
                        prop="ymoney"
                        label="应收款（￥）"
                        width="155">
                        </el-table-column>
                        <el-table-column
                        prop="type"
                        label="检测内容"
                        width="165">
                        </el-table-column>
                        <el-table-column
                        prop="jindu"
                        label="收款进度"
                        width="285">
                            <template slot-scope="scope">
                                <el-progress :percentage="Number((scope.row.collect_money.substr(1) / scope.row.ymoney.substr(1) * 100).toFixed(0))"></el-progress>
                            </template>
                        </el-table-column>
                        <el-table-column
                        prop="account_id"
                        label="付款方"
                        width="225">
                        </el-table-column>
                        <el-table-column
                        prop="danhao"
                        label="委托编号"
                        width="162">
                        </el-table-column>
                        <el-table-column
                        prop="collecttime"
                        :formatter="dateFormat"
                        label="应收款时间"
                        width="155">
                        </el-table-column>
                    </el-table>
                    <div class="page flex">
                        <el-pagination
                            @size-change="handleSizeChange"
                            @current-change="handleCurrentChange"
                            :current-page.sync="page"
                            :page-size="per_page"
                            layout="total, prev, pager, next, jumper"
                            :total="total"
                            :pager-count="5">
                        </el-pagination>
                        <div class="sk flex">
                            <div class="li">总计应收：<em>￥{{ yingTotal }}元</em></div>
                            <div class="li">总计已收：<em>￥{{ yiTotal }}元</em></div>
                            <div class="li">总计未收：<em>￥{{ weiTotal }}元</em></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
  </template>

  <script>
    import { finance_index, finance_del, basis_entrust_index } from "@/api";
    import myheader from "@/components/common/header";
    import myleft from "@/components/common/left";
      export default {
          data () {
              return {
                // 委托单位列表
                danweiList: [],
                yingTotal: '0.00',
                yiTotal: '0.00',
                weiTotal: '0.00',
                // 筛选
                start_time: '', // 开始日期
                end_time: '', // 结束日期
                formInline: {
                    entrust_id: '',
                    serial: '',
                    date: '',
                    entrust_phone: ''
                },
                rules: {
                    entrust_id: [
                        { required: false, message: '请输入委托单位id', trigger: 'blur' }
                    ],
                    serial: [
                        { required: false, message: '请输入委托编号', trigger: 'blur' }
                    ],
                    date: [
                        { required: false, message: '请选择委托日期', trigger: 'change' }
                    ],
                    entrust_phone: [
                        { required: false, message: '请输入姓名', trigger: 'blur' }
                    ]
                },
                // 数据列表
                loading: false,
                tableData: [],
                total: 0,
                per_page: 10, //每页多少数据
                page: 1
              }
            },
            components: {
                myheader: myheader,
                myleft: myleft
            },
            methods: {
                // 日期范围回显
                changeDate(e) {
                    // console.log(e[0], e[1]);
                    this.start_time = e[0]; // 开始日期
                    this.end_time = e[1]; // 结束日期
                },
                // 列表
                financeIndex() {
                    this.loading = true;
                    finance_index().then((res) => {
                        // console.log(res.data.data);
                        this.loading = false;
                        if (res.data.code == 1) {
                            this.tableData = res.data.data.data;
                            this.total = res.data.data.total // 数据总条数
                        }
                    });
                },
                // 委托单位列表
                basisEntrustIndex() {
                    this.loading = true;
                    basis_entrust_index().then((res) => {
                        // console.log(res.data.data);
                        this.loading = false;
                        if (res.data.code == 1) {
                            this.danweiList = res.data.data.data;
                        }
                    });
                },
                // 删除选中项
                deleteSelect() {
                    this.$confirm('此操作将永久删除数据, 是否继续?', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                        }).then(() => {
                            
                        var val = this.multipleSelection;
                        var multipleSelection = val.map(item => item['id']).join(','); // 勾选值数组转字符串

                        finance_del({
                            ids: multipleSelection
                        }).then(res => {
                            // console.log(res);
                            if (res.data.code == 1) {
                                this.page = 1;
                                this.financeIndex(); // 调用数据列表函数
                            }
                        }).catch(error => {
                            console.log(error);
                        });

                        this.$message({
                            type: 'success',
                            message: '删除成功!'
                        });
                        }).catch(() => {
                        this.$message({
                            type: 'info',
                            message: '已取消删除'
                        });          
                    });
                },
                // 筛选
                submitForm(formName) {
                    this.$refs[formName].validate((valid) => {
                        if (valid) {
                            // console.log(this.formInline.name);
                            this.loading = true;
                            finance_index({
                                params: {
                                    entrust_id: this.formInline.entrust_id,
                                    serial: this.formInline.serial,
                                    entrust_phone: this.formInline.entrust_phone,
                                    start_time: this.start_time,
                                    end_time: this.end_time,
                                    page: this.page
                                }
                            }).then((res) => {
                                // console.log(res.data.data);
                                this.loading = false;
                                if (res.data.code == 1) {
                                    this.tableData = res.data.data.data;
                                    this.total = res.data.data.total // 数据总条数
                                }
                            });
                        } else {
                            console.log('error submit!!');
                            return false;
                        }
                    });
                },
                // 当选择项发生变化时会触发该事件
                handleSelectionChange(val) {
                    this.multipleSelection = val;
                    // var multipleSelection = val.map(item => item['id']).join(','); // 勾选值数组转字符串
                    // console.log(multipleSelection)
                },
                // 每页条数
                handleSizeChange(val) {
                    console.log(`每页 ${val} 条`);
                },
                // 当前页
                handleCurrentChange(page) {
                    // console.log(`当前页: ${page}`);
                    this.loading = true;
                    detection_task_index({
                        params: { page }
                    }).then((res) => {
                        // console.log(res.data.data);
                        this.loading = false;
                        if (res.data.code == 1) {
                            this.tableData = res.data.data.data;
                        }
                    });
                },
                // 时间戳转日期格式
                dateFormat(row) {
                    // console.log(row.collecttime*1000)
                    let data = row.collecttime * 1000
                    let dtime = new Date(data)
                    const year = dtime.getFullYear()
                    let month = dtime.getMonth() + 1
                    if (month < 10) {
                        month = '0' + month
                    }
                    let day = dtime.getDate()
                    if (day < 10) {
                        day = '0' + day
                    }
                    let hour = dtime.getHours()
                    if (hour < 10) {
                        hour = '0' + hour
                    }
                    let minute = dtime.getMinutes()
                    if (minute < 10) {
                        minute = '0' + minute
                    }
                    let second = dtime.getSeconds()
                    if (second < 10) {
                        second = '0' + second
                    }
                    return year+ '-' + month+ '-' + day + ' ' + hour + ':' + minute + ':' + second
                },
            },
            created() {
                this.financeIndex(); // 列表
                this.basisEntrustIndex() // 委托单位列表
            },
            // 解决表格fixed错位问题
            updated() {
                if (this.$refs.singleTable && this.$refs.singleTable.doLayout) {
                    this.$refs.singleTable.doLayout()
                }
            }
      }
  </script>
  
  <!-- Add "scoped" attribute to limit CSS to this component only -->
  <style>
        .yingshou .el-table__row td:nth-child(3) .cell{
            color: #409EFF;
        }
        .yingshou .el-table__row td:last-child .cell{
            line-height: 32px;
            /* overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis; */
        }
  </style>
  


// WEBPACK FOOTER //
// src/components/yingshou.vue